import React, { Component } from "react";
import "../../../node_modules/video-react/dist/video-react.css"; // import css
import { Player } from 'video-react'

export default class Video extends Component {
	
	render () {
		
		let src 	= this.props.src;
		let poster 	= this.props.poster;
		
		console.log('poster: ' + poster);
		
		if (this.props.width) {
			
			let width 	= this.props.width;
			let height 	= this.props.height;
						    
		    return (
			    					
				<div className="c-media" style={{paddingTop:((height / width) * 100) + '%'}}>
					<Player
						playsInline
						poster={poster}
						src={src}
					/>
				</div>
			    
			)
			
		} else {
			return null;
		}
			
	}
}
